import { render, staticRenderFns } from "./Aproveitamento.vue?vue&type=template&id=111bb3d8&scoped=true&lang=pug&"
import script from "./Aproveitamento.vue?vue&type=script&lang=js&"
export * from "./Aproveitamento.vue?vue&type=script&lang=js&"
import style0 from "./Aproveitamento.styl?vue&type=style&index=0&id=111bb3d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111bb3d8",
  null
  
)

export default component.exports